// import React, { useRef, useState, useEffect } from "react";
// import { FFmpeg } from "@ffmpeg/ffmpeg";
// import { fetchFile } from "@ffmpeg/util";
// import { FILE_TYPES } from "../../../config/cloudinary.config";
// import { toast } from "sonner";
// import { FaVideo } from "react-icons/fa";
// import LoaderSpinner from "../../molecules/Loader/Loader.spinner";
// import { uploadToCloudinary } from "../../../utils/upload.cloudinary";
// import { useMakeRequest } from "../../../hooks/useMakeRequest";
// import { STATUS_URL } from "../../../constant/resource";
// import { useAppSelector } from "../../../redux/ReduxType";

// const VideoStatus = ({ close }: { close: () => void }) => {
//   const ffmpeg = new FFmpeg();
//   const [video, setVideo] = useState<File | null>(null);
//   const [videoDuration, setVideoDuration] = useState<number>(0);
//   const [trimStart, setTrimStart] = useState(0);
//   const [isTreaming, setIsTreaming] = useState(false);
//   const [trimmedVideo, setTrimmedVideo] = useState<File | null>(null);
//   const videoRef = useRef<HTMLInputElement>(null);
//   const [caption, setCaption] = useState("");
//   const previewVideoRef = useRef<HTMLVideoElement>(null);
//   const [isUploading, setIsUploading] = useState(false);
//   const makeRequest = useMakeRequest();
//   const User = useAppSelector((state) => state.user);
//   const handleVideo = (e: React.ChangeEvent<HTMLInputElement>) => {
//     const file = e.target.files?.[0];
//     if (!file) return;

//     if (!FILE_TYPES.video.acceptedFormats.includes(file.type)) {
//       return toast.error("Please select a valid video file");
//     }

//     setVideo(file);
//     const url = URL.createObjectURL(file);

//     const videoElement = document.createElement("video");
//     videoElement.src = url;
//     videoElement.onloadedmetadata = () => {
//       setVideoDuration(videoElement.duration);
//     };
//   };

//   const handleTrimStartChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//     const value = Number(e.target.value);
//     const maxStart = Math.max(0, videoDuration - 30);
//     const newStart = Math.min(value, maxStart);

//     setTrimStart(newStart);

//     if (previewVideoRef.current) {
//       previewVideoRef.current.currentTime = newStart;
//     }
//   };

//   const handleFile = async () => {
//     await ffmpeg.load();
//     if (!video) return;

//     const endTime = Math.min(trimStart + 30, videoDuration);

//     try {
//       setIsTreaming(true);
//       ffmpeg.writeFile("input.mp4", await fetchFile(video));

//       // Explicitly convert and re-encode video to ensure compatibility
//       await ffmpeg.exec([
//         "-i",
//         "input.mp4",
//         "-ss",
//         `${trimStart}`,
//         "-to",
//         `${endTime}`,
//         "-c:v",
//         "libx264",
//         "-preset",
//         "ultrafast", // Fastest encoding
//         "-crf",
//         "28", // Slightly lower quality for faster processing
//         "output.mp4",
//       ]);

//       const data: any = await ffmpeg.readFile("output.mp4");
//       // console.log("data --->", data);
//       const trimmedVideoFile = new File(
//         [data.buffer],
//         `status_video_${new Date().toISOString()}.mp4`,
//         { type: "video/mp4" }
//       );

//       setTrimmedVideo(trimmedVideoFile);
//       toast.success("Video trimmed successfully!");
//     } catch (error) {
//       console.error("Trimming error:", error);
//       toast.error("Failed to trim video");
//     } finally {
//       setIsTreaming(false);
//     }
//   };

//   const handleUploadTrimmed = async () => {
//     if (!trimmedVideo) {
//       toast.error("No trimmed video to upload");
//       return;
//     }

//     try {
//       setIsUploading(true);
//       const videoUrl = await uploadToCloudinary(trimmedVideo);

//       const payload = {
//         media: videoUrl?.url,
//         text: caption,
//         author: User?._id,
//         statusType: "video",
//       };

//       await makeRequest(
//         STATUS_URL,
//         "POST",
//         payload,
//         () => toast.success("Status uploaded"),
//         () => toast.error("Upload failed"),
//         () => {
//           setCaption("");
//           setTrimmedVideo(null);
//           close();
//         }
//       );
//     } catch (error) {
//       console.error("Upload failed", error);
//       toast.error("Video upload failed");
//     } finally {
//       setIsUploading(false);
//     }
//   };

//   return (
//     <div className="flex flex-col items-center w-full p-4 space-y-4">
//       {/* Video File Input */}
//       {isUploading ? (
//         // <p>loading ...</p>
//         <LoaderSpinner color={"blue"} />
//       ) : (
//         <div className="h-[350px] overflow-auto">
//           <div className="relative w-full max-w-md">
//             <input
//               ref={videoRef}
//               onChange={handleVideo}
//               type="file"
//               name="videoFile"
//               id="videoFile"
//               className="hidden"
//             />
//             <div className="flex items-center justify-between">
//               <FaVideo
//                 onClick={() => videoRef.current?.click()}
//                 className="w-10 h-10 cursor-pointer text-blue-600"
//               />
//               {video && (
//                 <span className="text-sm text-gray-600">{video.name}</span>
//               )}
//             </div>
//           </div>

//           {/* Video Preview */}
//           {video && (
//             <div className="w-full max-w-md">
//               <video
//                 ref={previewVideoRef}
//                 className="w-full aspect-video border-2"
//                 src={URL.createObjectURL(video)}
//                 controls
//               />

//               {/* Custom Slider */}
//               <div className="relative w-full h-10 mt-4">
//                 <div className="absolute w-full h-2 bg-gray-300 top-4 rounded-full">
//                   <div
//                     className="absolute h-2 bg-blue-500 rounded-full"
//                     style={{
//                       left: `${(trimStart / videoDuration) * 100}%`,
//                       width: `${
//                         (Math.min(30, videoDuration - trimStart) /
//                           videoDuration) *
//                         100
//                       }%`,
//                     }}
//                   />
//                 </div>
//                 <input
//                   type="range"
//                   min={0}
//                   max={videoDuration}
//                   value={trimStart}
//                   onChange={handleTrimStartChange}
//                   className="absolute w-full h-8 opacity-0 cursor-pointer"
//                 />
//                 <div className="flex justify-between text-sm mt-2 text-deepBg">
//                   <span>Start: {trimStart.toFixed(1)}s</span>
//                   <span>
//                     End: {Math.min(trimStart + 30, videoDuration).toFixed(1)}s
//                   </span>
//                 </div>
//               </div>

//               {/* Trim Button */}
//               <button
//                 onClick={handleFile}
//                 className="mt-4 w-full px-4 py-2 bg-blue-500 text-white rounded flex items-center justify-center"
//               >
//                 {isTreaming ? <LoaderSpinner color={"white"} /> : "Trim"}
//               </button>
//             </div>
//           )}

//           {/* Trimmed Video Preview */}
//           {trimmedVideo && (
//             <div className="mt-4 w-full max-w-md text-darkBg">
//               <h3 className="text-sm font-medium mb-2">Trimmed Video:</h3>
//               <video
//                 className="w-full aspect-video border-2"
//                 src={URL.createObjectURL(trimmedVideo)}
//                 controls
//                 autoPlay
//               />
//               <input
//                 className="w-full outline-none text-black p-2 my-2 border-[2px] border-gray-500 rounded-sm"
//                 type="text"
//                 placeholder="Say something ..."
//                 value={caption}
//                 onChange={(e) => setCaption(e.target.value)}
//               />
//               <button
//                 onClick={handleUploadTrimmed}
//                 disabled={isUploading}
//                 className={`px-4 py-2 rounded-sm ${
//                   isUploading
//                     ? "bg-gray-400 cursor-not-allowed"
//                     : "bg-darkBg text-white"
//                 }`}
//               >
//                 {isUploading ? "Uploading..." : "Upload"}
//               </button>
//             </div>
//           )}
//         </div>
//       )}
//     </div>
//   );
// };

// export default VideoStatus;

// ------- version 2 ----------
import React, { useRef, useState, useEffect, useCallback } from "react";
import { FFmpeg } from "@ffmpeg/ffmpeg";
import { fetchFile, toBlobURL } from "@ffmpeg/util";
import { FILE_TYPES } from "../../../config/cloudinary.config";
import { toast } from "sonner";
import { FaVideo } from "react-icons/fa";
import { MdCloudUpload, MdEdit } from "react-icons/md";
import LoaderSpinner from "../../molecules/Loader/Loader.spinner";
import { uploadToCloudinary } from "../../../utils/upload.cloudinary";
import { useMakeRequest } from "../../../hooks/useMakeRequest";
import { STATUS_URL } from "../../../constant/resource";
import { useAppSelector } from "../../../redux/ReduxType";

const VideoStatus = ({ close }: { close: () => void }) => {
  // Initialize FFmpeg only once when component mounts
  const [ffmpegLoaded, setFfmpegLoaded] = useState(false);
  const ffmpegRef = useRef(new FFmpeg());
  const [video, setVideo] = useState<File | null>(null);
  const [videoDuration, setVideoDuration] = useState<number>(0);
  const [trimStart, setTrimStart] = useState(0);
  const [isTrimming, setIsTrimming] = useState(false);
  const [trimmedVideo, setTrimmedVideo] = useState<File | null>(null);
  const videoRef = useRef<HTMLInputElement>(null);
  const [caption, setCaption] = useState("");
  const previewVideoRef = useRef<HTMLVideoElement>(null);
  const [isUploading, setIsUploading] = useState(false);
  const [videoObjectUrl, setVideoObjectUrl] = useState<string | null>(null);
  const [trimmedVideoUrl, setTrimmedVideoUrl] = useState<string | null>(null);
  const makeRequest = useMakeRequest();
  const User = useAppSelector((state) => state.user);

  // Load FFmpeg only once when component mounts
  useEffect(() => {
    const loadFFmpeg = async () => {
      try {
        // Use CDN URLs for faster loading
        const baseURL = "https://unpkg.com/@ffmpeg/core@0.12.2/dist/umd";
        await ffmpegRef.current.load({
          coreURL: await toBlobURL(
            `${baseURL}/ffmpeg-core.js`,
            "text/javascript"
          ),
          wasmURL: await toBlobURL(
            `${baseURL}/ffmpeg-core.wasm`,
            "application/wasm"
          ),
        });
        setFfmpegLoaded(true);
      } catch (error) {
        console.error("Failed to load FFmpeg:", error);
        toast.error("Failed to initialize video editor");
      }
    };

    loadFFmpeg();

    // Clean up object URLs on unmount
    return () => {
      if (videoObjectUrl) URL.revokeObjectURL(videoObjectUrl);
      if (trimmedVideoUrl) URL.revokeObjectURL(trimmedVideoUrl);
    };
  }, []);

  const handleVideo = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const file = e.target.files?.[0];
      if (!file) return;

      if (!FILE_TYPES.video.acceptedFormats.includes(file.type)) {
        return toast.error("Please select a valid video file");
      }

      // Clean up previous URL if exists
      if (videoObjectUrl) URL.revokeObjectURL(videoObjectUrl);

      // Create new URL for the video
      const url = URL.createObjectURL(file);
      setVideoObjectUrl(url);
      setVideo(file);

      // Get video duration
      const videoElement = document.createElement("video");
      videoElement.src = url;
      videoElement.onloadedmetadata = () => {
        setVideoDuration(videoElement.duration);
        // Reset trim values when new video is loaded
        setTrimStart(0);
      };
    },
    [videoObjectUrl]
  );

  const handleTrimStartChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const value = Number(e.target.value);
      const maxStart = Math.max(0, videoDuration - 30);
      const newStart = Math.min(value, maxStart);

      setTrimStart(newStart);

      if (previewVideoRef.current) {
        previewVideoRef.current.currentTime = newStart;
      }
    },
    [videoDuration]
  );

  const trimVideo = useCallback(async () => {
    if (!video || !ffmpegLoaded) {
      toast.error(
        ffmpegLoaded ? "No video selected" : "Video editor is still loading"
      );
      return;
    }

    const endTime = Math.min(trimStart + 30, videoDuration);

    try {
      setIsTrimming(true);

      // Clean up previous trimmed video URL
      if (trimmedVideoUrl) URL.revokeObjectURL(trimmedVideoUrl);

      // Write the file to FFmpeg's virtual file system
      ffmpegRef.current.writeFile("input.mp4", await fetchFile(video));

      // Optimize FFmpeg command for speed
      // Using 'copy' for codecs when possible to avoid re-encoding
      // Only re-encode if we need to trim precisely
      const needsReencode = trimStart > 0 || endTime < videoDuration;

      if (needsReencode) {
        // We need to trim, so we'll have to re-encode
        await ffmpegRef.current.exec([
          "-i",
          "input.mp4",
          "-ss",
          `${trimStart}`,
          "-to",
          `${endTime}`,
          "-c:v",
          "libx264",
          "-preset",
          "veryfast", // Faster encoding
          "-crf",
          "28", // Lower quality for faster processing
          "-c:a",
          "aac",
          "-b:a",
          "128k", // Lower audio bitrate
          "-movflags",
          "+faststart", // Optimize for web playback
          "output.mp4",
        ]);
      } else {
        // No trimming needed, just copy the streams to avoid re-encoding
        await ffmpegRef.current.exec([
          "-i",
          "input.mp4",
          "-c:v",
          "copy",
          "-c:a",
          "copy",
          "-movflags",
          "+faststart",
          "output.mp4",
        ]);
      }

      const data = await ffmpegRef.current.readFile("output.mp4");

      // Create output file
      const trimmedVideoFile: any = new File(
        [data],
        `status_video_${Date.now()}.mp4`,
        { type: "video/mp4" }
      );

      // Create and store object URL for preview
      const url = URL.createObjectURL(trimmedVideoFile);
      setTrimmedVideoUrl(url);
      setTrimmedVideo(trimmedVideoFile);

      toast.success("Video processed successfully!");
    } catch (error) {
      console.error("Video processing error:", error);
      toast.error("Failed to process video");
    } finally {
      setIsTrimming(false);
    }
  }, [video, ffmpegLoaded, trimStart, videoDuration, trimmedVideoUrl]);

  const handleUploadTrimmed = useCallback(async () => {
    if (!trimmedVideo) {
      toast.error("No processed video to upload");
      return;
    }

    try {
      setIsUploading(true);
      const videoUrl = await uploadToCloudinary(trimmedVideo);

      const payload = {
        media: videoUrl?.url,
        text: caption,
        author: User?._id,
        statusType: "video",
      };

      await makeRequest(
        STATUS_URL,
        "POST",
        payload,
        () => toast.success("Status uploaded successfully"),
        () => toast.error("Upload failed"),
        () => {
          setCaption("");
          setTrimmedVideo(null);
          if (trimmedVideoUrl) URL.revokeObjectURL(trimmedVideoUrl);
          setTrimmedVideoUrl(null);
          close();
        }
      );
    } catch (error) {
      console.error("Upload failed", error);
      toast.error("Video upload failed");
    } finally {
      setIsUploading(false);
    }
  }, [trimmedVideo, caption, User?._id, makeRequest, close, trimmedVideoUrl]);

  // Show loading indicator while FFmpeg is loading
  if (!ffmpegLoaded && !isUploading) {
    return (
      <div className="flex flex-col items-center justify-center w-full p-8 space-y-4">
        <LoaderSpinner color={"blue"} />
        <p className="text-sm text-gray-600">Initializing video editor...</p>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center w-full p-4 space-y-4">
      {isUploading ? (
        <div className="flex flex-col items-center justify-center h-64">
          <LoaderSpinner color={"blue"} />
          <p className="mt-4 text-sm text-gray-600">Uploading your video...</p>
        </div>
      ) : (
        <div className="h-[350px] overflow-auto w-full">
          <div className="relative w-full max-w-md mx-auto">
            <input
              ref={videoRef}
              onChange={handleVideo}
              type="file"
              name="videoFile"
              id="videoFile"
              className="hidden"
              accept={FILE_TYPES.video.acceptedFormats.join(",")}
            />

            <div className="flex items-center justify-between mb-4">
              <button
                onClick={() => videoRef.current?.click()}
                className="flex items-center space-x-2 text-blue-600 hover:text-blue-800 transition-colors"
              >
                <FaVideo className="w-6 h-6" />
                <span className="text-sm font-medium">
                  {video ? "Change Video" : "Select Video"}
                </span>
              </button>
              {video && (
                <span className="text-sm text-gray-600 truncate max-w-[200px]">
                  {video.name}
                </span>
              )}
            </div>

            {/* Video Preview */}
            {video && videoObjectUrl && (
              <div className="w-full max-w-md mx-auto bg-gray-50 p-4 rounded-lg">
                <video
                  ref={previewVideoRef}
                  className="w-full aspect-video rounded border border-gray-300"
                  src={videoObjectUrl}
                  controls
                />

                {/* Custom Slider */}
                <div className="relative w-full mt-4">
                  <p className="text-sm font-medium mb-2">
                    Select start position (max 30 seconds will be used)
                  </p>
                  <div className="relative w-full h-10">
                    <div className="absolute w-full h-2 bg-gray-300 top-4 rounded-full">
                      <div
                        className="absolute h-2 bg-blue-500 rounded-full"
                        style={{
                          left: `${(trimStart / videoDuration) * 100}%`,
                          width: `${
                            (Math.min(30, videoDuration - trimStart) /
                              videoDuration) *
                            100
                          }%`,
                        }}
                      />
                    </div>
                    <input
                      type="range"
                      min={0}
                      max={videoDuration}
                      step={0.1}
                      value={trimStart}
                      onChange={handleTrimStartChange}
                      className="absolute w-full h-8 opacity-0 cursor-pointer"
                    />
                    <div className="flex justify-between text-sm mt-4 text-gray-700">
                      <span>Start: {trimStart.toFixed(1)}s</span>
                      <span>
                        End:{" "}
                        {Math.min(trimStart + 30, videoDuration).toFixed(1)}s
                      </span>
                    </div>
                  </div>

                  {/* Process Button */}
                  <button
                    onClick={trimVideo}
                    disabled={isTrimming}
                    className={`mt-4 w-full px-4 py-3 text-white rounded-md 
                    ${
                      isTrimming
                        ? "bg-gray-400"
                        : "bg-blue-600 hover:bg-blue-700"
                    } 
                    transition-colors flex items-center justify-center`}
                  >
                    {isTrimming ? (
                      <>
                        <LoaderSpinner color={"white"} />
                        <span className="ml-2">Processing...</span>
                      </>
                    ) : (
                      "Process Video"
                    )}
                  </button>
                </div>
              </div>
            )}

            {/* Trimmed Video Preview */}
            {trimmedVideo && trimmedVideoUrl && (
              <div className="mt-6 w-full max-w-md mx-auto bg-white p-4 rounded-lg border border-gray-200">
                <h3 className="text-md font-medium mb-2 text-gray-800">
                  Processed Video
                </h3>
                <video
                  className="w-full aspect-video rounded border border-gray-300"
                  src={trimmedVideoUrl}
                  controls
                  autoPlay
                />

                <div className="relative mt-4">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <MdEdit className="text-gray-500" />
                  </div>
                  <input
                    className="w-full pl-10 py-2 px-3 border text-gray-800 border-gray-300 rounded-md 
                    focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    type="text"
                    placeholder="Add a caption..."
                    value={caption}
                    onChange={(e) => setCaption(e.target.value)}
                  />
                </div>

                <button
                  onClick={handleUploadTrimmed}
                  disabled={isUploading}
                  className={`mt-4 w-full px-4 py-3 rounded-md flex items-center justify-center
                    ${
                      isUploading
                        ? "bg-gray-400 cursor-not-allowed"
                        : "bg-green-600 hover:bg-green-700"
                    } 
                    text-white transition-colors`}
                >
                  {isUploading ? (
                    <>
                      <LoaderSpinner color={"white"} />
                      <span className="ml-2">Uploading...</span>
                    </>
                  ) : (
                    <>
                      <MdCloudUpload className="mr-2" />
                      Upload Status
                    </>
                  )}
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default VideoStatus;
